import React from "react";
import { ICellRendererParams } from "ag-grid-community";

export interface GridCheckBoxCellParams<TData = any> extends ICellRendererParams<TData> {
	checkedValue?: string;
	uncheckedValue?: string;
	onChange?: (newValue: string, params: ICellRendererParams<TData>) => void;
	editable?: boolean;
}

export const GridCheckBoxCell = <TData,>(props: GridCheckBoxCellParams<TData>) => {
	if (props.node?.rowPinned === "bottom") return null;

	const checkedValue = props.checkedValue ?? "Y";
	const uncheckedValue = props.uncheckedValue ?? "N";
	const isChecked = String(props.value ?? "") === String(checkedValue);
	const isEditable = props.editable ?? true;

	const handleToggle = () => {
		if (!isEditable || !props.data) return;

		const newValue = isChecked ? uncheckedValue : checkedValue;
		props.onChange?.(newValue, props);
	};

	return (
		<div
			className={`ag-custom-checkbox-cell flex items-center justify-center h-full w-full${isEditable ? " is-editable" : ""}`}
			onClick={handleToggle}
		>
			<input
				type="checkbox"
				className="ag-custom-checkbox-input"
				checked={isChecked}
				readOnly
				tabIndex={-1}
				disabled={!isEditable}
			/>
		</div>
	);
};
